import { createColumnHelper } from "@tanstack/react-table";
import { Fragment, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/context/store";
import { usePagination } from "src/hooks/usePagination";
import { getMasterEscalationList } from "src/services/invoice-api";
import { invoiceActions } from "src/context/invoice-slice";
import arrowDown from "src/assets/arrow-down.svg";
// import InvoiceApprovalDetails from "./InvoiceApprovalDetails";
import Table1 from "src/components/ui/table1.component";
import InvoiceApprovalDetails from "./InvoiceApprovalDetails";

const columnHelper = createColumnHelper();

const InvoiceApprovalHomepage = () => {
    const [loading, setLoading] = useState(false);
    const [totalRowCount, setTotalRowCount] = useState(0);
    const { invoiceMasterApprovalList } = useSelector((state: RootState) => state.invoice);
    const { pagination, onPaginationChange, pageIndex, pageSize, resetPagination } = usePagination();
    const [search, setSearch] = useState("");

    const dispatch = useDispatch();

    const columns = useMemo(
        () => [
            columnHelper.accessor("invoice_data", {
                cell: (info: any) => (
                    <div className="flex gap-10 items-center">
                        <div className="flex py-3 items-center">
                            <span className="font-semibold text-base text-black">
                                <span className="text-[#49484C]">Invoice No:</span> {info?.row?.original?.invoice_number}
                            </span>
                        </div>
                        <div className="h-5 w-0.5 bg-gray-300"></div>
                        <div className="flex py-3 items-center">
                            <span className="font-semibold text-base text-black">FUID No: {info.row.original.fuid}</span>
                        </div>
                    </div>
                ),
            }),
            columnHelper.accessor("expand_toggle", {
                enableSorting: false,
                cell: (info: any) => {
                    const isExpanded = info.row.getIsExpanded();

                    return (
                        <div className="flex justify-end gap-1 pr-1">
                            <button
                                onClick={() => info.row.toggleExpanded()}
                                className="flex items-center justify-center w-8 h-8 p-1.5 border-2 border-[#D0D0D0] rounded-md cursor-pointer bg-[#F1F1F1] shadow-sm"
                            >
                                <img
                                    src={arrowDown}
                                    alt="Expand/Collapse"
                                    className={`w-5 h-5 duration-300 transition-transform ease-in-out ${isExpanded ? "-rotate-180" : "rotate-0"}`}
                                />
                            </button>
                        </div>
                    );
                },
            }),
        ],
        []
    );

    const fetchPendingInvoice = async () => {
        try {
            setLoading(true);
            let query = {
                page: pageIndex,
                page_size: pageSize,
                search: search,
            }

            const response = await getMasterEscalationList(query);
            setTotalRowCount(response?.data?.total);
            dispatch(invoiceActions.setInvoiceMasterApprovalList(response?.data?.data));
        } catch (error) {
            console.error("Failed to fetch orders:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        // dispatch(ordActions.setProductsData([]));
        // dispatch(ordActions.setCounterLocationData([]));
        // dispatch(ordActions.setOrderDetailsFiltered([]));
        // dispatch(ordActions.setSelectedCounterData([]));
        fetchPendingInvoice();
    }, [pageIndex, pageSize]);

    let pageCount = Math.ceil(totalRowCount / (pageSize || 1));

    const handleSearch = (searchQuery: string) => {
        setSearch(searchQuery);
        resetPagination();
    };

    useEffect(() => {
        const timeout = setTimeout(() => {
            resetPagination();
        }, 300);
        return () => clearTimeout(timeout);
    }, [search]);

    const selectedRowHandler = (rows: any) => {
        console.log(rows);
    };


    return (
        <Fragment>
            <div className="pb-10">
                <Table1
                    title="Invoice Details"
                    subtitle="View and manage escalated invoices requests"
                    showheader={false}
                    isLoading={loading}
                    renderSubComponent={(row) => (
                        <div className="transition transition ease-in-out duration-200 transform">
                            <InvoiceApprovalDetails resetPagination={resetPagination} setLoading={setLoading} setTotalRowCount={setTotalRowCount} row={row} />
                        </div>
                    )}
                    getRowCanExpand={() => true}
                    data={invoiceMasterApprovalList ?? []}
                    columns={columns}
                    isGlobalSearch={true}
                    manualPagination={true}
                    pageCount={pageCount}
                    pagination={pagination}
                    onPaginationChange={onPaginationChange}
                    getSelectedRows={selectedRowHandler}
                    onGlobalSearch={handleSearch}
                />
            </div>
        </Fragment>
    );
};

export default InvoiceApprovalHomepage;
